import { render, staticRenderFns } from "./recommend.vue?vue&type=template&id=2a1d827d&scoped=true&"
import script from "./recommend.vue?vue&type=script&lang=js&"
export * from "./recommend.vue?vue&type=script&lang=js&"
import style0 from "./recommend.vue?vue&type=style&index=0&id=2a1d827d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1d827d",
  null
  
)

export default component.exports